import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthContext } from "@providers/AuthProvider";
import { useTranslation } from "react-i18next";

export const AuthenticationPage: React.FC = () => {
  const { i18n } = useTranslation();
  const [queryParameters] = useSearchParams();
  const { onRequestLogin } = useAuthContext();

  const entry = queryParameters.get("entry");
  const lang = queryParameters.get("error");

  useEffect(() => {
    if (lang !== null) {
      i18n.changeLanguage(lang, (err) => {
        if (!err) {
          localStorage.setItem("preferredLanguage", lang);
        }
      });
    }

    if (entry !== null) {
      onRequestLogin();
    } else {
      // handle error
    }
  }, [entry, lang]);

  return null;
};
